import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  FetchDataParams,
  ServicePricesListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const SERVICE_PRICES_QUERY_KEY = 'servicePrices';

export const useServicePricesQuery = (params: FetchDataParams) => {
  const { fetchUrl, paginationParams } = params;

  return useQuery({
    queryKey: [SERVICE_PRICES_QUERY_KEY, fetchUrl, paginationParams],
    queryFn: () =>
      HttpClient.request<ServicePricesListResponseData>({
        method: 'GET',
        url: fetchUrl,
        params: paginationParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!fetchUrl,
  });
};
